module.exports = __webpack_public_path__ + "img/OhringeMarkeEigenbau.053b9a1c.svg";